import React, { createContext, useContext } from 'react';
import { toast } from 'react-toastify';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const showToast = (message, type = 'info', options = {}) => {
    const defaultOptions = {
      position: 'top-right',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'dark',
      ...options
    };

    switch (type) {
      case 'success':
        toast.success(message, defaultOptions);
        break;
      case 'error':
        toast.error(message, defaultOptions);
        break;
      case 'warning':
        toast.warning(message, defaultOptions);
        break;
      case 'info':
      default:
        toast.info(message, defaultOptions);
        break;
    }
  };

  const showSuccessToast = (message, options = {}) => {
    showToast(message, 'success', options);
  };

  const showErrorToast = (message, options = {}) => {
    showToast(message, 'error', options);
  };

  const showWarningToast = (message, options = {}) => {
    showToast(message, 'warning', options);
  };

  const showInfoToast = (message, options = {}) => {
    showToast(message, 'info', options);
  };

  return (
    <ToastContext.Provider value={{ 
      showToast, 
      showSuccessToast, 
      showErrorToast, 
      showWarningToast, 
      showInfoToast 
    }}>
      {children}
    </ToastContext.Provider>
  );
};

export default ToastProvider; 